import { jsx } from 'react/jsx-runtime';
import { createElement } from 'react';
import { IconWrapper } from '../IconWrapper/IconWrapper.js';
import '../../../tslib.es6-a39f91fc.js';
import '../../../index-6ea95111.js';
import '../../../style-inject.es-1f59c1d0.js';

var AdviceRecommendation = (function (props) {
    return createElement(IconWrapper, props, jsx("path", { stroke: "currentColor", strokeWidth: 2, d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2.868a2 2 0 0 0-1.715.971l-1.56 2.6a1 1 0 0 1-1.714 0l-1.56-2.6A2 2 0 0 0 7.868 17H5a2 2 0 0 1-2-2V5Z" }), jsx("path", { fill: "currentColor", d: "m11.046 8.885.6-1.619a.5.5 0 0 1 .937 0l.603 1.628a.5.5 0 0 0 .257.279l1.591.746a.5.5 0 0 1 0 .905l-1.585.743a.5.5 0 0 0-.26.291l-.602 1.758a.5.5 0 0 1-.946 0l-.598-1.75a.5.5 0 0 0-.275-.297l-1.707-.739a.5.5 0 0 1 0-.917l1.714-.742a.5.5 0 0 0 .27-.286Z" }));
});

export default AdviceRecommendation;
//# sourceMappingURL=AdviceRecommendation.js.map
